module.exports = __webpack_public_path__ + "static/sdk-emoji-524397e54aec6cce4fa6cde1a21fbb1a.gif";